
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/[name]",
      function () {
        return require("private-next-pages/about/[name].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/[name]"])
      });
    }
  